import styled from '@emotion/styled';

interface FreeTrialBannerProps {
	bannerValue?: string;
	platform?: string;
	daysLeft: number;
	expired: boolean;
}

interface TextContentProps {
	daysLeft: number;
	expired: boolean;
}

const FreeTrialBanner = ({
	bannerValue,
	platform,
	daysLeft,
	expired,
}: FreeTrialBannerProps) => {
	const BannerDiv = styled.div`
		background-color: #e043b1;
		color: #fff;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		z-index: 99;
		padding: 0.5rem;
		height: 45px;
		top: calc(${bannerValue === 'double' ? '45px' : '0px'} + var(--usertour-banner-height, 0px));
		left: 0px;
	`;

	const BannerButton = styled.button`
		box-sizing: border-box;
		overflow: visible;
		margin: 0;
		font-family: inherit;
		text-transform: none;
		align-items: center;
		justify-content: center;
		z-index: auto !important;
		display: inline-block;
		font-weight: 400;
		text-align: center;
		text-decoration: none;
		vertical-align: middle;
		user-select: none;
		border: 1px solid transparent;
		font-size: 1rem;
		border-radius: 0.25rem;
		transition:
			color 0.15s ease-in-out,
			background-color 0.15s ease-in-out,
			border-color 0.15s ease-in-out,
			box-shadow 0.15s ease-in-out;
		border-color: #fff;
		margin-left: 0.5rem;
		color: #e043b1;
		padding: 0.25rem 0.75rem;
		background-color: #ffffff;
		line-height: 1.3;
		cursor: pointer;

		&:hover,
		&:focus {
			color: #e043b1;
			text-decoration: none;
			background-color: #f3f3f4;
		}
	`;

	const TextContent = ({ daysLeft, expired }: TextContentProps) => {
		return daysLeft > 0 && !expired ? (
			<>
				You're on a free trial with{' '}
				<span className="days-left-number days-left-js">{daysLeft}</span>{' '}
				{daysLeft === 1 ? 'day' : 'days'} left.
			</>
		) : (
			<>Your trial has ended. Don't let your social media marketing flop!</>
		);
	};

	return (
		<BannerDiv className="freetrial-banner">
			<TextContent daysLeft={daysLeft} expired={expired} />
			<BannerButton
				className="freetrial-banner-button"
				onClick={() => {
					window.location.href =
						platform === 'social' ? '/settings/upgrade' : '_#';
				}}
			>
				{daysLeft > 0 ? 'Upgrade Now!' : 'See Plans'}
			</BannerButton>
		</BannerDiv>
	);
};

export default FreeTrialBanner;
